/** Server timestamps are stored in UTC (naive, no "Z"). Parse them as UTC; the browser shows local time.
 *  (new Date("2026-10-11T15:21:45") would read a bare timestamp as LOCAL time - 5.5 hours off in IST.) */
export function parseServerTime(v: any): Date {
  if (v == null || v === "" || typeof v === "number") return new Date(v || 0);
  if (v instanceof Date) return v;
  let s = String(v).trim().replace(" ", "T");
  if (!/[zZ]$|[+-]\d\d:?\d\d$/.test(s)) s += "Z";
  return new Date(s);
}
export const fmtServerTime = (v: any) => (v ? parseServerTime(v).toLocaleString() : "—");
